import { render } from "./IssuesPanel.vue?vue&type=template&id=7d3040d2&scoped=true"
import script from "./IssuesPanel.vue?vue&type=script&lang=js"
export * from "./IssuesPanel.vue?vue&type=script&lang=js"

import "./IssuesPanel.vue?vue&type=style&index=0&id=7d3040d2&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d3040d2"]])

export default __exports__